import React from 'react';
import { Icon } from '@tcc/crate';
import cx from 'classnames';
import { getMessage } from '@tcc/i18n';
import styles from './ApplicationsPanel.css';

interface ApplicationHeaderProps {
  name: string;
  date: Date;
  thumbnailUri: string;
  isExpanded: boolean;
  onToggle: () => void;
  testId: string;
  formatDate: (dateString: Date) => string;
}

const ApplicationHeader = ({
  name,
  date,
  thumbnailUri,
  isExpanded,
  onToggle,
  testId,
  formatDate,
}: ApplicationHeaderProps) => (
  <div 
    className={styles.applicationsPanelHeader}
    onClick={onToggle}
  >
    <div className={styles.applicationsPanelContent}>
      <img 
        src={thumbnailUri} 
        alt={name}
        className={styles.applicationsPanelSatelliteImage}
        data-test-id="application-thumbnail"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      />
      <div className={styles.applicationsPanelInfo}>
        <div className={styles.applicationsPanelName} data-test-id="application-name">
          {name === '' ? getMessage('legend.unknown') : name}
        </div>
        <div className={styles.applicationsPanelDate} data-test-id="application-date">
          {formatDate(date)}
        </div>
      </div>
    </div>
    <button
      type="button"
      className={styles.applicationsPanelExpandButton}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      <Icon
        className={cx(styles.applicationsPanelChevron, { 'expanded': isExpanded })}
        glyph={Icon.set.ARROW_RIGHT}
        testId={`${testId}-chevron`}
      />
    </button>
  </div>
);

export default ApplicationHeader;
export type { ApplicationHeaderProps };
